const parseDueYmd = (value) => {
  if (value === null || value === undefined || String(value).trim() === "") {
    return null;
  }
  const normalized = String(value).trim().slice(0, 10);
  const timestamp = Date.parse(normalized);
  if (Number.isNaN(timestamp)) return null;
  return new Date(timestamp);
};

const toYmd = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getInstallmentDueDateOrderError = (installments) => {
  const rows = (Array.isArray(installments) ? installments : [])
    .map((row, index) => ({
      num: Number(row?.installment_number ?? index + 1),
      due: parseDueYmd(row?.due_date),
    }))
    .filter((row) => Number.isFinite(row.num) && row.num > 0 && row.due)
    .sort((a, b) => a.num - b.num);

  for (let i = 1; i < rows.length; i += 1) {
    if (rows[i].due.getTime() <= rows[i - 1].due.getTime()) {
      return `Installment #${rows[i].num} due date must be after installment #${rows[i - 1].num}.`;
    }
  }

  return null;
};

export const getMinDueDateForInstallmentRow = (installments, rowIndex) => {
  const rows = Array.isArray(installments) ? installments : [];
  if (rowIndex <= 0) return undefined;

  const previousDue = parseDueYmd(rows[rowIndex - 1]?.due_date);
  if (!previousDue) return undefined;

  const minDate = new Date(previousDue);
  minDate.setDate(minDate.getDate() + 1);
  return toYmd(minDate);
};

const sameId = (a, b) => String(a ?? "") === String(b ?? "");

export const getStandaloneFeeInstallmentDueDateError = ({
  installmentNumber,
  dueDate,
  existingInstallments = [],
  excludeInstallmentId = null,
}) => {
  const num = Number(installmentNumber);
  const due = parseDueYmd(dueDate);
  if (!Number.isFinite(num) || num < 1 || !due) return null;

  const rows = (Array.isArray(existingInstallments) ? existingInstallments : [])
    .filter(
      (row) =>
        !excludeInstallmentId ||
        !sameId(
          row?.organization_ems_fee_installment_id ?? row?.id,
          excludeInstallmentId
        )
    )
    .map((row) => ({
      num: Number(row?.installment_number),
      due: parseDueYmd(row?.due_date),
    }))
    .filter((row) => Number.isFinite(row.num) && row.due);

  const previous = rows.find((row) => row.num === num - 1);
  if (previous && due.getTime() <= previous.due.getTime()) {
    return `Due date must be after installment #${previous.num}.`;
  }

  const next = rows.find((row) => row.num === num + 1);
  if (next && due.getTime() >= next.due.getTime()) {
    return `Due date must be before installment #${next.num}.`;
  }

  return null;
};

export const getMinDueDateForStandaloneInstallment = ({
  installmentNumber,
  existingInstallments = [],
  excludeInstallmentId = null,
}) => {
  const num = Number(installmentNumber);
  if (!Number.isFinite(num) || num < 2) return undefined;

  const previous = (Array.isArray(existingInstallments) ? existingInstallments : [])
    .filter(
      (row) =>
        !excludeInstallmentId ||
        !sameId(
          row?.organization_ems_fee_installment_id ?? row?.id,
          excludeInstallmentId
        )
    )
    .find((row) => Number(row?.installment_number) === num - 1);

  const previousDue = parseDueYmd(previous?.due_date);
  if (!previousDue) return undefined;

  const minDate = new Date(previousDue);
  minDate.setDate(minDate.getDate() + 1);
  return toYmd(minDate);
};
